var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height"},[_c('v-responsive',{staticClass:"align-center text-center fill-height"},[_c('v-btn',{attrs:{"loading":_vm.state.loading,"disabled":_vm.state.loading},on:{"click":_vm.anaf}},[_vm._v("ACEES ANAF")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }